export default ({
  carouselContainer,
  nextButton,
  previousButton,
  pagingContainer,
  autoplayTime,
}) => {
  if (!carouselContainer || !nextButton) {
    return;
  }
  let interval,
    position = 0;
  const previous = previousButton;
  const next = nextButton;
  const views = carouselContainer.querySelectorAll(".view");
  const buttons = pagingContainer.querySelectorAll("button");

  views[position].setAttribute("style", `transform: translateX(${-100}%)`);
  buttons[position].classList.add("highlight");

  interval = setInterval(() => {
    slideTo(position === views.length - 1 ? 0 : position + 1, true);
  }, autoplayTime);

  previous.addEventListener(
    "click",
    e => {
      slideTo(position === 0 ? views.length - 1 : position - 1, false);
    },
    false
  );

  next.addEventListener(
    "click",
    e => {
      slideTo(position === views.length - 1 ? 0 : position + 1, true);
    },
    false
  );

  buttons.forEach((button, index) => {
    button.addEventListener(
      "click",
      e => {
        if (index !== position) slideTo(index);
      },
      false
    );
  });

  function slideTo(nextPosition, direction) {
    clearInterval(interval);
    const forward =
      typeof direction === "undefined" ? nextPosition > position : direction;
    const currentView = views[position];
    const nextView = views[nextPosition];
    updatePosition(nextPosition);
    for (let view of views) {
      view.classList.remove("transition");
    }
    nextView.setAttribute(
      "style",
      `transform: translateX(${forward ? 0 : -200}%)`
    );
    // Cheap timeout implementation to avoid transitionEnd events
    setTimeout(() => {
      currentView.classList.add("transition");
      nextView.classList.add("transition");
      currentView.setAttribute(
        "style",
        `transform: translateX(${forward ? -200 : 0}%)`
      );
      nextView.setAttribute("style", `transform: translateX(${-100}%)`);
      interval = setInterval(() => {
        slideTo(position === views.length - 1 ? 0 : position + 1, true);
      }, autoplayTime);
    }, 30);
  }

  function updatePosition(nextPosition) {
    position = nextPosition;
    for (let button of buttons) {
      button.classList.remove("highlight");
    }
    buttons[nextPosition].classList.add("highlight");
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/carousel.js